<script setup lang='ts'>
import { APP_ROUTER, provinceName } from '@qctsw/common'
import { numFormat, timeFrom } from '@qctsw/utils'
import { getComplaintCollectiveStatus, goAppPage } from '@/shared/function'
import type { CollectiveComplainResponse } from '~/server/types'

const props = withDefaults(defineProps<{
  item: CollectiveComplainResponse
}>(), {

})

const car = computed(() => {
  const car: {
    brandName: string
    brandId: number
    series: { seriesId: number, seriesName: string }[]
  }[] = []

  for (const item of props.item.seriesLs) {
    const brand = car.find(brand => brand.brandId === item.brandId)
    if (brand) {
      brand.series.push({
        seriesId: item.seriesId,
        seriesName: item.seriesName,
      })
    }
    else {
      car.push({
        brandName: item.brandName,
        brandId: item.brandId,
        series: [
          {
            seriesId: item.seriesId,
            seriesName: item.seriesName,
          },
        ],
      })
    }
  }

  return car
})
const brands = computed(() => {
  return car.value.map(item => ({ brandName: item.brandName, brandId: item.brandId }))
})
</script>

<template>
  <div class="flex cursor-pointer border-1 border-slate-2 rounded-md">
    <div class="header font-bold flex-shrink-0">
      集体投诉
    </div>
    <div class="flex-grow min-w-0 overflow-hidden p-4 flex flex-col justify-between">
      <NuxtLink :to="APP_ROUTER.collectiveDetail(item.id)" class="line-clamp-1 text-5 font-bold w-90% hover:text-orange-6">
        {{ item.title }}
      </NuxtLink>
      <div class="text-4">
        <div v-if="brands.length" class="mt-1">
          <span class="text-gray-4 text-3.5">涉及品牌：</span>
          <NuxtLink
            v-for="item in brands" :key="item.brandId"
            class=" hover:text-blue-5" :to="APP_ROUTER.complaintSearch({ carBrandId: item.brandId, carBrandName: item.brandName })"
          >
            {{ item.brandName }}
          </NuxtLink>
        </div>
        <div v-if="item.seriesLs.length" class="mt-1">
          <span class="text-gray-4 text-3.5">涉及车系：</span>
          <NuxtLink
            v-for="v in item.seriesLs" :key="v.seriesId"
            class=" hover:text-blue-5 pr-2"
            :to="APP_ROUTER.complaintSearch({ carBrandId: v.brandId, carSeriesId: v.seriesId, carBrandName: v.brandName, carSeriesName: v.seriesName })"
          >
            {{ v.seriesName }}
          </NuxtLink>
        </div>
        <div v-if="item.progressCode || item.progressCode === 0" class="mt-1">
          <span class="text-gray-4 text-3.5">状态：</span>
          <span class="text-red-5">{{ getComplaintCollectiveStatus(item.progressCode) }}</span>
        </div>
        <div v-if="provinceName(item.provinceIds)" class="w-80% line-clamp-1 text-3.5 mt-1">
          <span class="text-gray-4 text-3.5">涉及地区：</span>
          <NuxtLink :to="APP_ROUTER.complaintSearch()">
            {{ provinceName(item.provinceIds) }}
          </NuxtLink>
        </div>
      </div>
      <div class="flex items-center justify-between mt-3">
        <UtilContentTips
          size="12" :tips-data="{
            date: (item.lastComplainTime),
            lookCount: numFormat(item.lookCount)?.toString() ?? '0',
            commentCount: item.commentCount ?? '0',
            favorCount: item.goodCount ?? 0,
          }"
        />
        <div class="text-3 text-info">
          投诉量：{{ item.complainCount }}
        </div>
      </div>
    </div>
  </div>
</template>

<style lang='scss' scoped>
.header {
  writing-mode: vertical-lr;
  width: 48px;
  min-height: 155px;
  background: #f2f5fa;
  line-height: 3;
  text-align: center;
  letter-spacing: 8px;
  padding-top: 8px;
}
</style>
